import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { TagFormContext } from 'context';
import type { ComponentMode, Tag as TagConfig } from 'types';

import { TagForm, TagHeader } from './components';

type TagProps = {
  mode: ComponentMode;
};

export default function Tag({ mode }: TagProps) {
  const data = useLoaderData() as TagConfig | undefined;

  const { title: tagTitle, status } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const step = 1;
  const title = isUpdatedMode ? tagTitle : 'افزودن برچسب جدید';
  const defaultTitle = isUpdatedMode ? tagTitle : '';
  const defaultStatus: typeof status = isUpdatedMode ? status : 'Active';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <TagHeader>{title}</TagHeader>
      <TagFormContext
        mode={mode}
        step={step}
        defaultStatus={defaultStatus}
        defaultTitle={defaultTitle}
        ownerType='Tag'
        {...(isUpdatedMode ? data : {})}
      >
        <TagForm />
      </TagFormContext>
    </React.Fragment>
  );
}
